import { render, staticRenderFns } from "./kuozhanYd.vue?vue&type=template&id=83dcc4bc&scoped=true"
import script from "./kuozhanYd.vue?vue&type=script&lang=js"
export * from "./kuozhanYd.vue?vue&type=script&lang=js"
import style0 from "./kuozhanYd.vue?vue&type=style&index=0&id=83dcc4bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../youyidian_pc/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83dcc4bc",
  null
  
)

export default component.exports